/** Appended to fixture-only confirmations so they never read as a completed backend operation. */
export const LOCAL_ONLY_NOTICE = "Local preview only — no backend request was made.";

export function localOnly(description?: string): string {
  return description ? `${description} ${LOCAL_ONLY_NOTICE}` : LOCAL_ONLY_NOTICE;
}
